export const FEATURE_NAME = 'killSwitchState';

export interface EmergencyStopState {
  isConfigured: boolean;
  isActive: boolean;
  triggeredAt: string | null;
}

export interface KillSwitchState {
  state: boolean;
  error: any | null;
  isLoading: boolean;
  emergencyStop: EmergencyStopState;
}

export const initialEmergencyStopState: EmergencyStopState = {
  isConfigured: false,
  isActive: false,
  triggeredAt: null,
};

export const initialState: KillSwitchState = {
  state: false,
  isLoading: false,
  error: null,
  emergencyStop: initialEmergencyStopState,
};
